import React, { useState, useRef, useEffect } from 'react';


import * as mat from './lib/jsmatrix';
import { MatF32, VecF32 } from './lib/jsmatrix';
import { addz } from './pointUtils.js';
import {
    computeTransformedDistanceSquared
} from './viewUtils.js';
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color';
import {
    DrawObject,
    Polygon,
    LineStrip,
    Point,
    createProperties,
    Transform,
    Text
} from './geom.js';

import {
    zoom_scale,
    MIN_GRID_SIZE,
} from './commonView.js';


import {
    Data, copy
} from './utils.js';
import {
    RGBA
} from './color.js';

import {
    closestVertex,
    isClockwise,
    normal2D,
    findIntersectSet,
    simplifyLine,
} from './pointUtils.js';

import {
    AngleSlider,
    CheckBox,
    NumberInput,
    NumberInputTimeout
} from './inputComponents.js';
import { ACTION_MOUSE_MOVE, ACTION_MOUSE_CLICK_LEFT, ACTION_MOUSE_DOWN_LEFT, ACTION_MOUSE_UP_LEFT, ACTION_MOUSE_UP_RIGHT } from './actions';

const EDIT_STATE_WAITING = 0;
const EDIT_STATE_ADDING_POINTS = 1;

class CreatePointTool {
    constructor() {
        this.reset();
    }

    static new() {
        return new CreatePointTool();
    }

    reset() {
        this.state = EDIT_STATE_WAITING;
        this.currentObject = [];
        this.hoverIndex = -1;
    }

    updateVis(toolState) {

        const overlay = [];
        const { mouse, viewTransforms } = toolState;
        const { snappedMousePosWorld } = mouse;
        const { setOverlayObjects } = toolState.overlay;
        {
            const cursorStyle = Data.new({
                fillStyle: RGBA.PURPLE.cp().a(0.5)
            });

            overlay.push(
                DrawObject.new(Point.new(addz(snappedMousePosWorld), 5), cursorStyle, Transform.new(),
                    createProperties({
                        z: Infinity
                    }))
            );
        }


        const co = this.currentObject;

        const previewPoints = [...co, addz(snappedMousePosWorld)];
        if (previewPoints.length === 2) {

            overlay.push(
                DrawObject.new(LineStrip.new(MatF32.fromCols(previewPoints)),
                    Data.new({
                        strokeStyle: RGBA.RED.cp().a(0.5)
                    }))
            );
        } else if (previewPoints.length > 2) {

            overlay.push(
                DrawObject.new(Polygon.new(MatF32.fromCols(previewPoints)),
                    Data.new({
                        strokeStyle: RGBA.RED.cp().a(0.5),
                        fillStyle: RGBA.LIME.cp().a(0.5),
                    }))
            );
        }
        const currentStyle = Data.new({
            fillStyle: RGBA.VIOLET.cp().a(0.5)
        });

        const hoverPoint = Data.new({
            fillStyle: RGBA.RED
        });

        for (let i = 0; i < co.length; i++) {
            const oi = co[i];
            const st = i === this.hoverIndex ? hoverPoint : currentStyle;
            overlay.push(
                DrawObject.new(Point.new(oi, 5), st, Transform.new(),
                    createProperties({
                        z: Infinity
                    }))
            );
        }

        if (co.length > 0) {
            const lastPoint = co[co.length - 1];
            const dir = mat.fromTo(lastPoint, addz(snappedMousePosWorld));
            const mid = mat.add(lastPoint, mat.scale(dir, 0.5));
            const n = normal2D(dir);
            mat.normalize(n, n);
            const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([5, 0, 0]));
            const r = Math.sqrt(r2);
            const textpos = mat.add(mid, mat.scale(n, -r));

            overlay.push(DrawObject.new(Text.new(textpos, mat.norm(dir).toFixed(2)),
                Data.new(), Transform.new(), createProperties({
                    z: Infinity
                })));

        }

        setOverlayObjects(() => overlay);

    }

    render(toolState) {

        return null;



    }
    update(toolState, action) {
        const { type: actionType } = action;
        const { mouse, context, viewTransforms } = toolState;
        const { snappedMousePosWorld } = mouse;
        const { objects, setObjects, viewport } = context;

        const { requestVisUpdate } = toolState;

        if (this.state === EDIT_STATE_WAITING) {

            if (actionType === ACTION_MOUSE_CLICK_LEFT) {
                const editPoints = [addz(snappedMousePosWorld, 0)];

                this.state = EDIT_STATE_ADDING_POINTS;
                this.currentObject = editPoints;
                requestVisUpdate();

            } else if (actionType === ACTION_MOUSE_MOVE) {
                requestVisUpdate();
            }

        }
        else if (this.state === EDIT_STATE_ADDING_POINTS) {

            if (actionType === ACTION_MOUSE_CLICK_LEFT) {
                const co = this.currentObject;
                const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([5, 5, 0]));

                let closest = closestVertex(co, r2, addz(snappedMousePosWorld, 0));

                if (closest >= 0) {

                    const cellSize = zoom_scale(viewport.zoomLevel);
                    if (closest === 0 && co.length > 2) {

                        const clockWise = isClockwise(co);
                        const polypoints = clockWise ? co.reverse() : co;
                        const poly = Polygon.new(MatF32.fromCols(polypoints));
                        const color = RGBA.getIndexColor(Math.round(Math.random() * RGBA.DEFAULT_COLORS.length)).cp().a(0.75);
                        const dobj = DrawObject.new(poly, Data.new({
                            fillStyle: color,
                            strokeStyle: color.changeValue(-0.5)
                        }),
                            Transform.new(), createProperties({
                                gridCellLength: cellSize,
                                gridCellHeight: cellSize
                            })
                        );

                        this.reset();
                        setObjects(() => [...objects, dobj]);
                        requestVisUpdate();

                    }
                    else if (closest === co.length - 1) {
                        const line = LineStrip.new(MatF32.fromCols(co));
                        const color = RGBA.getIndexColor(Math.round(Math.random() * RGBA.DEFAULT_COLORS.length)).cp().a(0.75);

                        const dobj = DrawObject.new(line, Data.new(
                            {
                                strokeStyle: color,
                                lineWidth: 2
                            }
                        ), Transform.new(),
                            createProperties({
                                gridCellLength: cellSize,
                                gridCellHeight: cellSize
                            }));

                        this.reset();
                        setObjects(() => [...objects, dobj]);
                        requestVisUpdate();
                    }
                }
                else {

                    this.currentObject.push(addz(snappedMousePosWorld, 0));
                    requestVisUpdate();
                }
            }
            else if (actionType === ACTION_MOUSE_MOVE) {
                const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([5, 5, 0]));

                let closest = closestVertex(this.currentObject, r2, addz(snappedMousePosWorld, 0));
                this.hoverIndex = closest;
                requestVisUpdate();
            } else if (actionType === ACTION_MOUSE_UP_RIGHT) {
                this.reset();
                requestVisUpdate();
            }
        }

    }

}
//*********************************************************
const CREATE_RECT_STATE_WAITING = 0;
const CREATE_RECT_STATE_DOWN = 1;
class CreateRectTool {
    constructor() {
        this.reset();
    }

    static new() {
        return new CreateRectTool();
    }

    reset() {
        this.state = CREATE_RECT_STATE_WAITING;
        this.currentStart = null;
    }

    updateVis(toolState) {

        const overlay = [];
        const { mouse, viewTransforms } = toolState;
        const { snappedMousePosWorld } = mouse;
        const { setOverlayObjects } = toolState.overlay;
        const cursorStyle = Data.new({
            fillStyle: RGBA.PURPLE.cp().a(0.5)
        });

        overlay.push(
            DrawObject.new(Point.new(addz(snappedMousePosWorld), 5), cursorStyle, Transform.new(),
                createProperties({
                    z: Infinity
                }))
        );
        if (this.state === CREATE_RECT_STATE_DOWN) {
            const p0 = this.currentStart;
            const p1 = addz(snappedMousePosWorld, 0);

            const bmin = mat.cwiseMin(p0, p1);
            const bmax = mat.cwiseMax(p0, p1);
            const d = mat.fromTo(bmin, bmax);
            const b1 = mat.add(bmin, mat.scale(mat.X, d.at(0)));
            const b3 = mat.add(bmin, mat.scale(mat.Y, d.at(1)));
            const polypoints = MatF32.fromCols([
                bmin,
                b1,
                bmax,
                b3
            ]);

            const poly = Polygon.new(polypoints);
            const dobj = DrawObject.new(poly, Data.new({
                strokeStyle: RGBA.RED.cp().a(0.5),
                fillStyle: RGBA.LIME.cp().a(0.5),
            }));
            overlay.push(dobj);

            // show length
            const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([5, 0, 0]));
            const r = Math.sqrt(r2);
            {
                const mid = mat.add(bmin, mat.scale(mat.X, 0.5 * d.at(0)));
                const n = mat.Y;
                const textpos = mat.add(mid, mat.scale(n, -r));

                overlay.push(DrawObject.new(Text.new(textpos, d.at(0).toFixed(2)),
                    Data.new(), Transform.new(), createProperties({
                        z: Infinity
                    })));

            }
            {
                const mid = mat.add(bmax, mat.scale(mat.Y, -0.5 * d.at(1)));
                const n = mat.X;
                const textpos = mat.add(mid, mat.scale(n, r));

                overlay.push(DrawObject.new(Text.new(textpos, d.at(1).toFixed(2)),
                    Data.new(), Transform.new(), createProperties({
                        z: Infinity
                    })));

            }

        }
        setOverlayObjects(() => overlay);

    }

    render(toolState) {

        return null;



    }
    update(toolState, action) {
        const { type: actionType } = action;
        const { mouse, context, viewTransforms } = toolState;
        const { snappedMousePosWorld } = mouse;
        const { objects, setObjects, viewport } = context;

        const { requestVisUpdate } = toolState;


        if (this.state === CREATE_RECT_STATE_WAITING) {

            if (actionType === ACTION_MOUSE_DOWN_LEFT) {
                const editPoints = addz(snappedMousePosWorld, 0);

                this.state = CREATE_RECT_STATE_DOWN;
                this.currentStart = editPoints;
                requestVisUpdate();

            }

        }
        else if (this.state === CREATE_RECT_STATE_DOWN) {

            if (actionType === ACTION_MOUSE_UP_LEFT) {
                const p0 = this.currentStart;
                const p1 = addz(snappedMousePosWorld, 0);

                const bmin = mat.cwiseMin(p0, p1);
                const bmax = mat.cwiseMax(p0, p1);
                const d = mat.fromTo(bmin, bmax);
                const r2 = computeTransformedDistanceSquared(
                    viewTransforms.MCanvas2Viewport, VecF32.from([4, 0, 0]));
                const dx = d.at(0);
                const dy = d.at(1);
                if (dx * dx < r2 || dy * dy < r2) {
                    // points to close together
                    this.reset();
                    requestVisUpdate();
                }
                else {
                    // create points


                    const polypoints = [
                        bmin,
                        mat.add(bmin, mat.scale(mat.X, d.at(0))),
                        bmax,
                        mat.add(bmin, mat.scale(mat.Y, d.at(1)))
                    ];

                    const color = RGBA.getIndexColor(
                        Math.round(Math.random() * RGBA.DEFAULT_COLORS.length)).cp().a(0.75);

                    const poly = Polygon.new(MatF32.fromCols(polypoints));
                    const cellsize = zoom_scale(viewport.zoomLevel);
                    const dobj = DrawObject.new(poly, Data.new({
                        fillStyle: color,
                        strokeStyle: color.changeValue(-0.5)
                    }), Transform.new(), createProperties({
                        gridCellLength: cellsize,
                        gridCellHeight: cellsize


                    }));

                    this.reset();
                    setObjects(() => [...objects, dobj]);

                }
                this.reset();
                requestVisUpdate();

            } else if (actionType === ACTION_MOUSE_MOVE) {
                requestVisUpdate();
            }
            else if (actionType === ACTION_MOUSE_UP_RIGHT) {
                this.reset();
                requestVisUpdate();
            }
        }

    }

}


function PropertyWindow(props) {
    const obj = props.object;

    const [combineCellSize, setCombineCellSize] = useState(true);

    if (!obj) {
        return <div>
            No Object selected
      </div>
    }

    const data = obj.styleData;
    const fillColor = data.get("fillStyle", RGBA.WHITE);
    const strokeColor = data.get("strokeStyle", RGBA.WHITE);

    const alpha = obj.transform.alpha;
    const scale = obj.transform.scale;


    const z = obj.options.z;

    const onAlphaChange = value => {
        props.onChange({
            object: obj,
            index: props.index,
            values: {
                alpha: value
            }
        })
    };

    const onScaleChange = (sx, sy) => {
        props.onChange({
            object: obj,
            index: props.index,
            values: {
                scale: VecF32.from([sx, sy, 1])
            }
        })
    };

    const onBoundChange = (type, e) => {
        const options = {};
        options[type] = e;
        props.onChange({
            object: obj,
            index: props.index,
            options: options
        });
    }

    const onVanishChange = e => {
        props.onChange({
            object: obj,
            index: props.index,
            options: {
                showBoundVanishingLines: e
            }
        });
    };

    const handlePropertyChange = (prop, value) => {
        props.onChange({
            object: obj,
            index: props.index,
            options: {
                [prop]: value
            }
        });
    }
    const onFillColorChange = color => {
        const rgb = color.rgb;
        const newcolor = RGBA.new(rgb.r / 255, rgb.g / 255, rgb.b / 255, rgb.a);
        const newData = data.copy();
        newData.set("fillStyle", newcolor);
        props.onChange({
            object: obj,
            index: props.index,
            values: {
                styleData: newData
            }
        });

    };

    const onStrokeColorChange = color => {
        const rgb = color.rgb;
        const newcolor = RGBA.new(rgb.r / 255, rgb.g / 255, rgb.b / 255, rgb.a);
        const newData = data.copy();
        newData.set("strokeStyle", newcolor);
        props.onChange({
            object: obj,
            index: props.index,
            values: {
                styleData: newData
            }
        });

    };

    const cellSizeSetters = <>
        <NumberInputTimeout value={obj.options.gridCellLength}
            valueName="Grid cell length"
            timeout={250}
            size={6}
            handleChange={
                v => {
                    const size = Math.max(MIN_GRID_SIZE / 4, v);
                    handlePropertyChange("gridCellLength", size);
                    if (combineCellSize) {
                        handlePropertyChange("gridCellHeight",
                            size);
                    }
                }} />
        <NumberInputTimeout value={obj.options.gridCellHeight}
            valueName="Grid cell height"
            timeout={250}
            size={6}
            handleChange={
                v => {
                    const size = Math.max(MIN_GRID_SIZE / 4, v);

                    handlePropertyChange("gridCellHeight", size);
                    if (combineCellSize) {
                        handlePropertyChange("gridCellLength",
                            size);
                    }
                }} />
    </>;

    return <div>
        <span className="title">
            Object properties (
            <button onClick={() => props.handleDelete(obj, props.index)}>Delete</button>
            )
        </span>
        <div className="flex-container">
            <div className="flex-entry">
                <span className="subtitle">
                    Transform
                </span>
                <AngleSlider angle={alpha} angleName="Angle"
                    handleChange={onAlphaChange}
                    precision={4}
                />
                <NumberInput value={z} valueName="Height "
                    size={6}
                    handleChange={v => handlePropertyChange("z", Math.max(0, v))} />
                <NumberInput value={scale.at(0)} valueName="Scale x "
                    size={6}
                    handleChange={v => onScaleChange(v, scale.at(1))} />
                <NumberInput value={scale.at(1)} valueName="Scale y "
                    size={6}
                    handleChange={v => onScaleChange(scale.at(0), v)} />
            </div>

            <div className="flex-entry">
                <span className="subtitle">
                    Grid size
                </span>
                <CheckBox checked={combineCellSize} labelText="Use square cells"
                    handleChange={c => setCombineCellSize(() => c)} />
                {cellSizeSetters}
                <NumberInputTimeout value={obj.options.sideGridStart}
                    valueName="Grid cell start"
                    timeout={500}
                    size={6}
                    handleChange={
                        v => {
                            handlePropertyChange("sideGridStart",
                                Math.max(0, Math.min(z, v)));
                        }} />
            </div>
            <div className="flex-entry">
                <span className="subtitle">
                    Grid display
                </span>
                <CheckBox checked={obj.options.displayCellLength}
                    handleChange={c => handlePropertyChange("displayCellLength", c)}
                    labelText="Cell length"
                />
                <CheckBox checked={obj.options.showBoundGridBottom}
                    handleChange={c => onBoundChange("showBoundGridBottom", c)}
                    labelText="Bottom grid"
                />
                <CheckBox checked={obj.options.showBoundGridTop}
                    handleChange={c => onBoundChange("showBoundGridTop", c)}
                    labelText="Top grid"
                />
                <CheckBox checked={obj.options.showSideGridFront}
                    handleChange={c => onBoundChange("showSideGridFront", c)}
                    labelText="Front grid"
                />
                <CheckBox checked={obj.options.showSideGridBack}
                    handleChange={c => onBoundChange("showSideGridBack", c)}
                    labelText="Rear grid"
                />
                <CheckBox checked={obj.options.showBoundVanishingLines}
                    handleChange={c => onVanishChange(c)}
                    labelText="Vanishing lines"
                />
            </div>
            <div className="flex-entry">
                <span className="subtitle">
                    Color
                </span>
                <div>
                    Fill color:
        <ColorPicker color={fillColor} handleChange={onFillColorChange}></ColorPicker>
                </div>
                <div>
                    Stroke color:
        <ColorPicker color={strokeColor} handleChange={onStrokeColorChange}></ColorPicker>
                </div>
            </div>
        </div>
    </div >
}
function ColorPicker(props) {
    const [displayPicker, setDisplayPicker] = useState(false);

    const color = props.color;
    const handleChange = props.handleChange;

    const handleClick = () => {
        setDisplayPicker(!displayPicker);
    };


    const handleClose = () => {
        setDisplayPicker(false);
    };

    const styles = reactCSS({
        'default': {
            color: {
                width: '36px',
                height: '14px',
                borderRadius: '2px',
                background: color.toString(),
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                transform: 'translate(-100%, 0%)'
            },
        },
    });

    return (
        <div>
            <div style={styles.swatch} onClick={handleClick}>
                <div style={styles.color} />
            </div>
            {displayPicker ? <div className="color-popover">
                <div className="color-cover" onClick={handleClose} />
                <div className="color-container">
                    <SketchPicker color={
                        {
                            r: Math.round(255 * color.r()),
                            g: Math.round(255 * color.g()),
                            b: Math.round(255 * color.b()),
                            a: color.a()
                        }
                    } onChange={handleChange} />
                </div>
            </div> : null}

        </div>
    )
}


const SELECT_WAITING = 4;
const SELECT_SELECTED = 5;
const SELECT_DRAGGING = 6;
const SELECT_DRAGGING_FINISHED = 7;
class SelectEditTool {

    constructor() {
        this.reset();
    }

    static new() {
        return new SelectEditTool();
    }
    reset() {
        this.state = SELECT_WAITING;
        this.currentSelectIndex = -1;
        this.hoverIndex = -1;
        this.moveDownMouseWorld = VecF32.from([0, 0]);
    }

    render(toolState) {
        // TODO maybe use additional component
        const { context } = toolState;
        const { objects, setObjects, viewport } = context;

        const selIdx = this.currentSelectIndex;
        const { requestVisUpdate } = toolState;


        let handleDelete = (object, index) => {
            const newObjects = [...objects];
            newObjects.splice(index, 1);
            setObjects(() => newObjects);
            this.reset();
            requestVisUpdate();

        };

        const changeHandler = data => {
            const { index, object, options, values } = data;

            if (options !== undefined) {
                const newOptions = copy(object.options);
                Object.assign(newOptions, data.options);
                object.options = newOptions;
            }

            if (values) {
                if (values.alpha !== undefined) {
                    const trans = object.transform.copy();
                    trans.setAlpha(values.alpha);
                    object.setTransform(trans);
                }

                if (values.scale !== undefined) {
                    const trans = object.transform.copy();
                    trans.setScale(values.scale);
                    object.setTransform(trans);
                }

                if (values.styleData !== undefined) {
                    object.styleData = values.styleData;
                }
            }
            setObjects(() => {
                const objectsNew = [...objects];
                objectsNew[index] = object;
                return objectsNew;
            });
            requestVisUpdate();

        };

        const handleClearAll = () => {
            this.reset();
            context.setObjects(() => []);
        };
        const handleNoObject = (
            <div>
                <span className="title">No object selected</span>
                <button onClick={handleClearAll}
                >Clear all</button>
            </div>
        );
        return <div>
            {selIdx >= 0 ?
                <PropertyWindow object={selIdx >= 0 ? objects[selIdx] : null
                } index={selIdx}
                    onChange={changeHandler} handleDelete={handleDelete}
                    viewport={viewport}></PropertyWindow > :
                handleNoObject
            }
        </div>

    }

    updateVis(toolState) {

        const { setOverlayObjects } = toolState.overlay;
        const { mouse, context, viewTransforms } = toolState;
        const { mousePosWorld } = mouse;
        const { objects } = context;
        const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([6, 6, 0]));

        const overlay = [];
        if (this.currentSelectIndex >= 0) {
            const obj = objects[this.currentSelectIndex];
            const drawableWorld = obj.drawableWorld;
            const center = mat.copy(mat.subvec(mat.mult(obj.M, mat.hvec(obj.drawable.center, 1)), 0, 3));
            const centerxy = mat.copy(mat.subvec(center, 0, 2));
            const pDrawable = Point.new(center, 6);
            const styleData = Data.new();
            if (mat.norm2Squared(mat.sub(centerxy, mousePosWorld)) < r2) {
                styleData.set("fillStyle", RGBA.RED);

            }
            const style = Data.new({
                strokeStyle: RGBA.GREEN.cp().a(1),
                fillStyle: RGBA.WHITE.cp().a(0.5),
                lineWidth: (4 * obj.styleData.get("lineWidth", 1))
            });

            overlay.push(DrawObject.new(
                drawableWorld, style, Transform.new(),
                createProperties({ z: obj.options.z }), obj.id - 0.5));


            overlay.push(DrawObject.new(
                pDrawable, styleData, Transform.new(),
                createProperties({ z: Infinity })));

        }

        if (this.hoverIndex >= 0) {
            const obj = objects[this.hoverIndex];

            let drawableWorld = obj.drawableWorld;
            const style = Data.new({
                strokeStyle: RGBA.RED.cp().a(1),
                fillStyle: RGBA.WHITE.cp().a(0.5),
                lineWidth: (2 * obj.styleData.get("lineWidth", 1))
            });

            overlay.push(DrawObject.new(
                drawableWorld, style, Transform.new(),
                createProperties({ z: obj.options.z }), obj.id - 0.85));
        }
        setOverlayObjects(() => overlay);
    }

    update(toolState, action) {

        const { type: actionType } = action;
        const { mouse, context, viewTransforms } = toolState;
        const { mousePosWorld } = mouse;
        const { objects, setObjects } = context;

        const { requestVisUpdate } = toolState;

        const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([4, 4, 0]));
        const r = Math.sqrt(r2);



        if (this.state === SELECT_WAITING) {
            const intersectSet = findIntersectSet(objects, mousePosWorld, r);

            if (intersectSet.length !== 0) {

                const objIndex = intersectSet[0].index;

                if (actionType === ACTION_MOUSE_CLICK_LEFT) {
                    this.currentSelectIndex = objIndex;
                    this.state = SELECT_SELECTED;
                    requestVisUpdate();


                }
                else if (actionType === ACTION_MOUSE_MOVE) {
                    this.hoverIndex = objIndex;
                    requestVisUpdate();


                }
            } else {
                this.hoverIndex = -1
                requestVisUpdate();


            }
        } else if (this.state === SELECT_SELECTED) {
            const intersectSet = findIntersectSet(objects, mousePosWorld, r);

            if (actionType === ACTION_MOUSE_CLICK_LEFT) {


                // check if already selected
                if (intersectSet.length === 0) {

                    // Outside -> go back
                    this.reset();
                    requestVisUpdate();

                    return;
                }
                let curIdx = -1;
                for (let i = 0; i < intersectSet.length; i++) {
                    if (intersectSet[i].index === this.currentSelectIndex) {
                        curIdx = i;
                        break;
                    }
                }

                // when the intersect set contains our current object, jump to the next one
                // if not, jump to the top of the set
                const selectIdx = curIdx >= 0 ? intersectSet[(curIdx + 1) % intersectSet.length].index : intersectSet[0].index;

                this.currentSelectIndex = selectIdx;
                requestVisUpdate();


            } else if (actionType === ACTION_MOUSE_DOWN_LEFT) {
                const currentObject = objects[this.currentSelectIndex];
                const center = mat.subvec(currentObject.drawableWorld.center, 0, 2);

                if (mat.norm2Squared(mat.sub(center, mousePosWorld)) < r2) {
                    this.moveDownMouseWorld = mousePosWorld;
                    this.state = SELECT_DRAGGING;
                    requestVisUpdate();


                }
            } else if (actionType === ACTION_MOUSE_MOVE) {
                if (intersectSet.length !== 0) {

                    this.hoverIndex = intersectSet[0].index;
                    requestVisUpdate();


                }
                else {
                    this.hoverIndex = -1;
                    requestVisUpdate();



                }

            }
        } else if (this.state === SELECT_DRAGGING) {
            if (actionType === ACTION_MOUSE_MOVE) {
                const oi = objects[this.currentSelectIndex];
                const oit = oi.transform;

                const tOld = oit.t;

                const dt = mat.fromTo(this.moveDownMouseWorld, mousePosWorld);

                this.moveDownMouseWorld = mousePosWorld;
                const dt3 = VecF32.from([dt.at(0), dt.at(1), 0]);
                oit.setTranslation(mat.add(tOld, dt3));
                oi.setTransform(oit);
                // TODO better copy object
                setObjects(() => {
                    const objectsNew = [...objects];
                    objectsNew[this.currentSelectIndex] = oi;
                    return objectsNew;
                });
                requestVisUpdate();


            }
            else if (actionType === ACTION_MOUSE_UP_LEFT) {
                this.state = SELECT_DRAGGING_FINISHED;
                this.moveDownMouseWorld = VecF32.from([0, 0]);
                requestVisUpdate();


            }
        }
        else if (this.state === SELECT_DRAGGING_FINISHED) {
            this.state = SELECT_SELECTED;
            requestVisUpdate();

        }

    }

}


const VIEW_STATE_WAITING = 8;
const VIEW_STATE_DRAGGING_VIEW = 9;


class ViewEditTool {
    constructor() {
        this.reset();
    }

    static new() {
        return new ViewEditTool();
    }

    render(toolState) {
        const { context, requestVisUpdate } = toolState;
        const { objects, setViewport } = context;
        const handleCenter = () => {
            requestVisUpdate();

            if (objects.length === 0) {
                setViewport(cur => {
                    const vp = Object.assign({}, cur);
                    vp.center = VecF32.from([0, 0, 0]);
                    return vp;
                });
                return;
            }
            const bmax = VecF32.from([-Infinity, -Infinity, -Infinity]);
            const bmin = VecF32.from([Infinity, Infinity, Infinity]);

            for (let i = 0; i < objects.length; i++) {
                const oi = objects[i];
                const dw = oi.drawableWorld;
                mat.cwiseMax(bmax, dw.bmax, bmax);
                mat.cwiseMin(bmin, dw.bmin, bmin);
            }

            const center = mat.scale(mat.add(bmin, bmax), 0.5);
            setViewport(cur => {
                const vp = Object.assign({}, cur);
                vp.center = center;
                return vp;
            });

        };
        return <button onClick={handleCenter}>Center view</button>;
    }

    reset() {
        this.state = VIEW_STATE_WAITING;
        this.lastMousePos = VecF32.from([0, 0]);
    }

    updateVis(toolState) {
        const overlay = [];
        const { setOverlayObjects } = toolState.overlay;
        const { context } = toolState;

        const { cam, viewport } = context;

        const viewMin = mat.sub(viewport.center, viewport.halfSize);
        const viewMax = mat.add(viewport.center, viewport.halfSize);

        const camPos = cam.pos;

        const clampedPos = mat.cwiseMin(viewMax, camPos);
        mat.cwiseMax(clampedPos, viewMin, clampedPos);


        const outside = clampedPos.at(0) !== camPos.at(0) || clampedPos.at(1) !== camPos.at(1);

        let camBGStyle = Data.new({
            fillStyle: RGBA.YELLOW.cp().a(0.25),
            strokeStyle: RGBA.BLACK
        });


        if (outside) {
            // camera outside
            camBGStyle.set("fillStyle", RGBA.RED.cp().a(0.25));
        }

        const pcenter = Point.new(clampedPos, 10);

        overlay.push(DrawObject.new(pcenter, camBGStyle, Transform.new(),
            createProperties({ z: Infinity })));

        setOverlayObjects(() => overlay);

    }

    update(toolState, action) {
        const { mouse, context, viewTransforms, requestVisUpdate } = toolState;
        const { type: actionType } = action;

        if (this.state === VIEW_STATE_WAITING) {
            if (actionType === ACTION_MOUSE_DOWN_LEFT) {

                // check if close to camPos

                this.lastMousePos = mouse.mousePosCanvas;
                this.state = VIEW_STATE_DRAGGING_VIEW;
                requestVisUpdate();

            }
        }
        else if (this.state === VIEW_STATE_DRAGGING_VIEW) {
            if (actionType === ACTION_MOUSE_MOVE) {

                const lastMousePos = this.lastMousePos;
                context.setViewport(current => {
                    const currentCenter = current.center;

                    const deltaCanvas = mat.fromTo(mouse.mousePosCanvas, lastMousePos);
                    this.lastMousePos = mouse.mousePosCanvas;
                    const deltaWorld = mat.subvec(mat.mult(viewTransforms.MCanvas2Viewport,
                        mat.hvec(addz(deltaCanvas, 0), 0))
                        , 0, 3
                    );
                    return {
                        center: mat.add(currentCenter, deltaWorld),
                        halfSize: current.halfSize,
                        zoomLevel: current.zoomLevel
                    };
                });
                requestVisUpdate();

            }
            else if (actionType === ACTION_MOUSE_UP_LEFT) {
                this.state = VIEW_STATE_WAITING;
                requestVisUpdate();

            }
        }
    }
}


class CameraEditTool {
    constructor() {
        this.reset();
    }

    static new() {
        return new CameraEditTool();
    }

    render(toolState) {

        const { context } = toolState;
        const { cam, setCam, perspective, setPerspective } = context;
        const { pos: camPos, dir: camDir } = cam;
        const { fov } = perspective;
        const camZ = camPos.at(2);

        const { r, theta, phi } = mat.cartesianToSpherical(camDir);

        const handleAngleChange = (theta, phi) => {
            setCam(currentCam => {
                return {
                    pos: currentCam.pos,
                    dir: mat.spherical(theta, phi, r),
                    up: currentCam.up
                };
            });
        };

        const handleCamChange = (x, y, z) => {
            setCam(currentCam => {
                return {
                    pos: VecF32.from([x, y, z]),
                    dir: currentCam.dir,
                    up: currentCam.up
                };
            });
        };
        return <div>
            <span className="title">
                Camera properties ( <button onClick={
                    () => {
                        setCam(() => {
                            return {
                                pos: VecF32.from([-0.4, -1.5, 1]),
                                dir: VecF32.from([0.4, 1.5, -1]),
                                up: mat.Z
                            }
                        });
                        setPerspective(cur => (
                            {
                                fov: mat.deg2rad(90),
                                aspect: cur.aspect
                            }));
                    }
                }>Reset</button>)
            </span>
            <div className="flex-container">
                <div className="flex-entry">
                    <span className="subtitle">
                        Camera position
                    </span>
                    <NumberInput value={camPos.at(0)} valueName="X"
                        handleChange={
                            v => handleCamChange(v, camPos.at(1), camPos.at(2))
                        }
                    />
                    <NumberInput value={camPos.at(1)} valueName="Y"
                        handleChange={
                            v => handleCamChange(camPos.at(0), v, camPos.at(2))
                        }
                    />
                    <NumberInput value={camZ} valueName="Height"
                        handleChange={
                            v => handleCamChange(camPos.at(0), camPos.at(1), v)
                        }
                    />

                </div>
                <div className="flex-entry">
                    <span className="subtitle">
                        Camera Orientation
                    </span>
                    <AngleSlider angle={phi} angleName="Longitude"
                        handleChange={a => handleAngleChange(theta, a)} />
                    <AngleSlider
                        angle={theta} angleName="Latitude" handleChange={a => handleAngleChange(a, phi)}
                        angleMin={1} angleMax={179} clockwise={false}
                    />
                    <AngleSlider angle={fov} angleName="Field of vision" handleChange={a => setPerspective(cur => (
                        {
                            fov: a,
                            aspect: cur.aspect
                        })
                    )}
                        angleMin={1} angleMax={179} clockwise={false} />
                </div>
            </div>
        </div >
    }

    reset() {
    }

    updateVis(toolState) {
    }

    update(toolState, action) {

    }
}



function jsonMatToMat(entry) {
    return MatF32.from(entry.data, entry.rows, entry.cols);
}

function jsonReviver(key, val) {
    if (key === "drawable") {
        const { type, points } = val;
        if (type === "Polygon") {
            return Polygon.new(jsonMatToMat(points));

        } else if (type === "LineStrip") {
            return LineStrip.new(jsonMatToMat(points));
        }
        else if (type === "Point") {
            return Point.new(jsonMatToMat(points), val.radius);

        } else if (type === "Text") {
            return Text.new(jsonMatToMat(points), val.text);
        }
    }
    else if (key === "transform") {
        const { t, alpha, scale } = val;
        return Transform.new(jsonMatToMat(t), alpha, jsonMatToMat(scale));
    }
    else if (key === "drawobject") {
        const { drawable, transform, properties, styleData, id } = val;

        return DrawObject.new(drawable, Data.new(styleData), transform, properties, id);
    }
    else if (key === "fillStyle") {
        const { r, g, b, a } = val;
        return RGBA.new(r, g, b, a);
    }
    else if (key === "strokeStyle") {
        const { r, g, b, a } = val;
        return RGBA.new(r, g, b, a);
    }
    else if (key === "objects") {
        return val.map(e => e.drawobject);
    }
    else if (key === "cam") {
        const { pos, dir, up } = val;
        return {
            pos: jsonMatToMat(pos),
            dir: jsonMatToMat(dir),
            up: jsonMatToMat(up),
        }
    }

    return val;
}


function LoadSaveComponent({ objects, setObjects, cam, setCam }) {
    const [showLoadWindow, setShowLoadWindow] = useState(false);
    const textRef = useRef(null);

    const onLoadClick = () => {
        const text = textRef.current.value;
        const scene = JSON.parse(text, jsonReviver);
        setObjects(current => [...current, ...scene.objects]);
        setCam(() => scene.cam);
        setShowLoadWindow(false);
    }
    const window = (
        <div>
            <div className="fullscreen transparent" onClick={
                () => setShowLoadWindow(() => false)
            } />
            <div className="load-window">
                <span className="title">
                    Type in your json object here:
                </span>
                <div>
                    <textarea ref={textRef} rows={10} cols={80}></textarea>
                </div>
                <button onClick={onLoadClick}>Load</button>
                <button onClick={() => setShowLoadWindow(false)}>Close</button>
            </div>
        </div>
    );

    const handleClickSave = () => {
        var a = document.createElement('a');
        var blob = new Blob([JSON.stringify({
            objects, cam: {
                pos: mat.toJSON(cam.pos),
                dir: mat.toJSON(cam.dir),
                up: mat.toJSON(cam.up)
            }
        })], {
            type: 'application/json'
        });
        a.href = URL.createObjectURL(blob);
        const currentTime = new Date();
        const formattedTime = currentTime.getFullYear() + "-" +
            (currentTime.getMonth() + 1) + "-" +
            currentTime.getDate()

        a.download = formattedTime + "_scene.json";
        a.click();

    };
    return (
        <div>
            <button onClick={handleClickSave}>Save to JSON</button>
            <button onClick={() => setShowLoadWindow(true)}>Load from JSON</button>
            {showLoadWindow ? window : null}
        </div>
    );

}

class LoadSaveTool {
    constructor() {
        this.reset();
    }

    static new() {
        return new LoadSaveTool();
    }

    reset() {
    }

    updateVis(toolState) {

    }

    render(toolState) {

        const { context } = toolState;
        const { objects, setObjects, cam, setCam } = context;
        return <LoadSaveComponent objects={objects} setObjects={setObjects}
            cam={cam} setCam={setCam}
        ></LoadSaveComponent>;

    }
    update(toolState, action) {

    }

}

const FREEHAND_STATE_WAITING = 0;
const FREEHAND_STATE_MOUSEDOWN = 1;

class FreeHandPolyTool {
    constructor() {
        this.reset();
    }

    static new() {
        return new FreeHandPolyTool();
    }

    reset() {
        this.state = FREEHAND_STATE_WAITING;
        this.currentObject = [];
    }

    updateVis(toolState) {

        const overlay = [];
        const { mouse } = toolState;
        const { mousePosWorld } = mouse;
        const { setOverlayObjects } = toolState.overlay;
        {
            const cursorStyle = Data.new({
                fillStyle: RGBA.PURPLE.cp().a(0.5)
            });

            overlay.push(
                DrawObject.new(Point.new(addz(mousePosWorld), 5), cursorStyle, Transform.new(),
                    createProperties({
                        z: Infinity
                    }))
            );
        }


        const co = this.currentObject;

        const previewPoints = [...co, addz(mousePosWorld)];
        if (previewPoints.length === 2) {

            overlay.push(
                DrawObject.new(LineStrip.new(MatF32.fromCols(previewPoints)),
                    Data.new({
                        strokeStyle: RGBA.RED.cp().a(0.5)
                    }))
            );
        } else if (previewPoints.length > 2) {

            overlay.push(
                DrawObject.new(Polygon.new(MatF32.fromCols(previewPoints)),
                    Data.new({
                        strokeStyle: RGBA.RED.cp().a(0.5),
                        fillStyle: RGBA.LIME.cp().a(0.5),
                    }))
            );
        }

        setOverlayObjects(() => overlay);

    }

    render(toolState) {

        return null;



    }
    update(toolState, action) {
        const { type: actionType } = action;
        const { mouse, context, viewTransforms } = toolState;
        const { mousePosWorld } = mouse;
        const { objects, setObjects, viewport } = context;

        const { requestVisUpdate } = toolState;

        if (this.state === FREEHAND_STATE_WAITING) {

            if (actionType === ACTION_MOUSE_DOWN_LEFT) {
                const editPoints = [addz(mousePosWorld, 0)];

                this.state = FREEHAND_STATE_MOUSEDOWN;
                this.currentObject = editPoints;
                requestVisUpdate();

            } else if (actionType === ACTION_MOUSE_MOVE) {
                requestVisUpdate();
            }

        }
        else if (this.state === FREEHAND_STATE_MOUSEDOWN) {

            if (actionType === ACTION_MOUSE_UP_LEFT) {
                const co = this.currentObject;

                if (co.length > 2) {
                    const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([1, 1, 0]));
                    const r = Math.sqrt(r2);
                    const clockWise = isClockwise(co);
                    let polypoints = clockWise ? co.reverse() : co;
                    polypoints = simplifyLine(polypoints, r).map(v => addz(v));
                    const poly = Polygon.new(MatF32.fromCols(polypoints));
                    const color = RGBA.getIndexColor(Math.round(Math.random() * RGBA.DEFAULT_COLORS.length)).cp().a(0.75);

                    const cellsize = zoom_scale(viewport.zoomLevel);
                    const dobj = DrawObject.new(poly, Data.new({
                        fillStyle: color,
                        strokeStyle: color.changeValue(-0.5)
                    }), Transform.new(), createProperties({
                        gridCellLength: cellsize,
                        gridCellHeight: cellsize

                    }));

                    this.reset();
                    setObjects(() => [...objects, dobj]);

                }
                this.reset();
                requestVisUpdate();

            } else if (actionType === ACTION_MOUSE_MOVE) {
                const co = this.currentObject;

                const r2 = computeTransformedDistanceSquared(viewTransforms.MCanvas2Viewport, VecF32.from([1, 1, 0]));
                const d2 = mat.norm2Squared(mat.sub(mat.subvec(co[co.length - 1], 0, 2), mousePosWorld));

                if (d2 < r2) {
                    requestVisUpdate();
                    return;
                }
                this.currentObject.push(addz(mousePosWorld, 0));

                requestVisUpdate();
            }
            else if (actionType === ACTION_MOUSE_UP_RIGHT) {
                this.reset();
                requestVisUpdate();
            }
        }

    }

}


function useViewportMove({
    enabled = true,
    borderSize = 10,
    speed = 1.0,
    mouse,
    viewTransforms,
    setViewport }) {

    const [moveState, setMoveState] = useState({
        dx: 0, dy: 0, moving: false
    });
    const { canvasSize } = viewTransforms;

    const { mousePosCanvas: mp } = mouse;

    let { dx: curdx, dy: curdy, moving: curmoving } = moveState;
    useEffect(() => {
        if (!curmoving) {
            return;
        }
        const interval = 100;

        const handle = setInterval(() => {

            setViewport(current => {
                const currentCenter = current.center;

                const cellsize = zoom_scale(current.zoomLevel);

                const l = speed * interval / 1000 * cellsize;
                const deltaWorld = VecF32.from([l * curdx, l * curdy, 0]);

                return {
                    center: mat.add(currentCenter, deltaWorld),
                    halfSize: current.halfSize,
                    zoomLevel: current.zoomLevel
                };
            });


        }, interval);
        return () => {
            clearInterval(handle);
        }
    }, [curmoving, curdx, curdy, setViewport, viewTransforms, speed]);


    const x = mp.at(0);
    const y = mp.at(1);

    useEffect(() => {
        // check sides
        let dx = 0;
        let dy = 0;
        if (mouse.inside) {
            if (x < borderSize) {
                dx -= 1;
            } else if (x > canvasSize.width - borderSize) {
                dx += 1;
            }
            if (y < borderSize) {
                dy -= 1;
            } else if (y > canvasSize.height - borderSize) {
                dy += 1;
            }
        }

        const moving = dx !== 0 || dy !== 0;
        setMoveState(() => ({
            moving,
            dx, dy
        }));
    }, [x, y, canvasSize.width, canvasSize.height, borderSize, mouse.inside]);


}

export {
    CreatePointTool,
    CreateRectTool,
    SelectEditTool,
    ViewEditTool,
    LoadSaveTool,
    FreeHandPolyTool,
    CameraEditTool,
    useViewportMove
}